import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Plus, Trash2, Save } from 'lucide-react';
import { Button } from '../../ui/button';
import { Input } from '../../ui/input';
import { API_RUEDA } from './RuedaSyncPanel';

const sel = 'rounded-md border border-gray-300 bg-white px-2 py-1.5 text-sm';

export const RuedaMapeoPanel = ({ onSaved }) => {
  const [data, setData] = useState(null);
  const [reglas, setReglas] = useState([]);

  useEffect(() => { axios.get(`${API_RUEDA}/mapeo`).then((r) => { setData(r.data); setReglas(r.data.reglas); }); }, []);
  if (!data) return null;

  const set = (i, k, v) => setReglas(reglas.map((r, j) => (j === i ? { ...r, [k]: v } : r)));
  const guardar = async () => {
    try {
      const r = await axios.put(`${API_RUEDA}/mapeo`, { reglas });
      setReglas(r.data.reglas);
      toast.success(`Mapeo guardado${r.data.asignados ? ` · ${r.data.asignados} importaciones categorizadas` : ''}`);
      onSaved?.();
    } catch { toast.error('No se pudo guardar'); }
  };

  return (
    <div className="space-y-4" data-testid="rueda-mapeo-panel">
      <p className="text-sm text-gray-600">
        Para cada categoría de la Rueda definí a qué categoría propia va. Con <b>palabra clave</b> podés separar por tipo
        (por ejemplo "hotel" → Hotelería, "paquete" → Paquetes Turísticos); se busca en el tipo y el nombre del prestador.
        Usá "+" para exigir varias palabras. La regla sin palabra clave es la opción por defecto. Lo que no coincida queda "sin categorizar".
      </p>
      {reglas.map((r, i) => (
        <div key={i} className="flex flex-col sm:flex-row gap-2 rounded-lg border p-3 bg-white" data-testid={`rueda-regla-${i}`}>
          <select className={sel} value={r.categoria_rueda} onChange={(e) => set(i, 'categoria_rueda', e.target.value)} data-testid={`rueda-regla-cat-${i}`}>
            {Object.entries(data.categorias_rueda).map(([k, l]) => <option key={k} value={k}>{l}</option>)}
          </select>
          <Input className="sm:w-56" placeholder="Palabra clave (opcional)" value={r.palabra_clave || ''} onChange={(e) => set(i, 'palabra_clave', e.target.value)} data-testid={`rueda-regla-clave-${i}`} />
          <select className={`${sel} flex-1`} value={r.categoria_id} onChange={(e) => set(i, 'categoria_id', e.target.value)} data-testid={`rueda-regla-destino-${i}`}>
            <option value="">Elegí categoría propia…</option>
            {data.categorias.map((c) => <option key={c.id} value={c.id}>{c.nombre}</option>)}
          </select>
          <Button variant="ghost" size="sm" onClick={() => setReglas(reglas.filter((_, j) => j !== i))}><Trash2 className="h-4 w-4 text-red-500" /></Button>
        </div>
      ))}
      <div className="flex gap-2">
        <Button variant="outline" size="sm" onClick={() => setReglas([...reglas, { categoria_rueda: 'turismo', palabra_clave: '', categoria_id: '' }])} data-testid="rueda-regla-agregar"><Plus className="h-4 w-4 mr-1" />Agregar regla</Button>
        <Button size="sm" onClick={guardar} data-testid="rueda-mapeo-guardar"><Save className="h-4 w-4 mr-1" />Guardar mapeo</Button>
      </div>
      {Object.keys(data.tipos_vistos).length > 0 && (
        <div className="rounded-lg bg-gray-50 p-3 text-xs text-gray-600" data-testid="rueda-tipos-vistos">
          <p className="font-medium mb-1">Tipos que aparecen en la Rueda (para armar palabras clave):</p>
          {Object.entries(data.tipos_vistos).map(([k, ts]) => <p key={k}><b>{data.categorias_rueda[k]}:</b> {ts.join(' · ')}</p>)}
        </div>
      )}
    </div>
  );
};
